import React, { FC } from "react";
import Svg, { Circle, G, Path, SvgProps } from "react-native-svg";

export interface ICustomSvgProps extends SvgProps {
	strokeColor?: string;
}

const AngryIcon: FC<ICustomSvgProps> = (props) => {
	return (
		<Svg width={props.width} height={props.height} viewBox="0 0 313 313">
			<G transform="matrix(1,0,0,1,-52.3109,-44.8266)">
				<Circle
					cx="208.495"
					cy="201.01"
					r="156.184"
					fill={props.color || "rgb(215,73,66)"}
				/>
			</G>
			<G transform="matrix(1,0,0,1,-64.275,-36.7654)">
				<G transform="matrix(-0.6192,0.59853,-0.59853,-0.6192,158.895,158.956)">
					<Path d="M-5.84,22.724L2.447,56.994C3.426,61.043 0.934,65.125 -3.115,66.104C-7.164,67.083 -11.247,64.59 -12.226,60.541L-33.367,-26.889C-34.346,-30.938 -31.854,-35.02 -27.805,-35.999C-23.756,-36.978 -19.674,-34.486 -18.695,-30.437L-15.575,-17.536C-11.431,-21.219 -5.975,-23.458 0,-23.458C12.947,-23.458 23.458,-12.947 23.458,0C23.458,12.947 12.947,23.458 0,23.458C-2.016,23.458 -3.973,23.203 -5.84,22.724Z" />
				</G>
				<G transform="matrix(-1,0,0,1,440.917,0)">
					<Path d="M179.035,160.492L188.688,166.613C191.718,168.534 195.737,167.634 197.658,164.605C199.579,161.575 198.679,157.555 195.65,155.634L130.229,114.151C127.2,112.23 123.18,113.13 121.259,116.16C119.338,119.19 120.238,123.209 123.268,125.13L148.91,141.39C147.467,142.211 146.103,143.224 144.855,144.431C136.838,152.18 136.621,164.98 144.37,172.996C152.119,181.013 164.919,181.23 172.935,173.481C176.635,169.905 178.674,165.253 179.035,160.492Z" />
				</G>
			</G>
			<G transform="matrix(1,0,0,1,-60.5458,-10.7439)">
				<Path d="M174.575,250.889C174.158,256.392 169.351,260.522 163.848,260.104C158.345,259.687 154.215,254.88 154.633,249.377C157.07,217.226 183.959,191.857 216.729,191.857C249.5,191.857 276.389,217.227 278.825,249.377C279.242,254.881 275.113,259.687 269.61,260.104C264.106,260.521 259.3,256.392 258.883,250.889C257.229,229.067 238.972,211.857 216.729,211.857C194.487,211.857 176.23,229.068 174.575,250.889Z" />
			</G>
		</Svg>
	);
};

export default AngryIcon;
